'use client'

import { useInView } from 'react-intersection-observer'
import { useEffect, useState } from 'react'
import { useGetCategoriesMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { usePathname, useRouter } from 'next/navigation'
import Link from 'next/link'
import ArrowLeftIcon from '@/shared/components/svgIcons/ArrowLeft'

export const Category = ({ currentConfig, changeConfigRequest }) => {
    const router = useRouter()
    const pathname = usePathname()
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    const [categories, setCategories] = useState([])
    const [getCategoriesCatalog] = useGetCategoriesMutation()

    useEffect(() => {
        getCategoriesCatalog(currentConfig.category_id)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setCategories(Object.values(res.data))
                }
                if (res.error) {
                    setCategories([])
                }
            })
            .catch((err) => {
                TOAST_ERROR('Ошибка получения категорий')
            })
    }, [currentConfig.category_id])

    return (
        <>
            <div
                ref={ref}
                className={`Category ${inView && 'animate__animated animate__slideInLeft'
                    }`}
            >
                {/* {!!categories.length && <h2>Категории</h2>} */}
                <div className={'categories'}>
                    <button
                        onClick={() => router.back()}
                        className="Category button-back"
                    >
                        <ArrowLeftIcon color='black' className={'arrow-left-icon'} width={20} height={20} />
                        <span>вернуться назад</span>
                    </button>
                    {categories.map((item) => {
                        return (
                            <Link
                                onClick={() =>
                                    changeConfigRequest({
                                        ...currentConfig,
                                        namePage: item.name,
                                        categories: [
                                            ...currentConfig.categories,
                                            pathname,
                                        ],
                                    })
                                }
                                key={item.category_id}
                                className={'category-catalog'}
                                href={`/` + item.catalog_href}
                            >
                                {item.name}
                            </Link>
                        )
                    })}
                </div>
            </div>
        </>
    )
}
